import React, { FunctionComponent } from "react";
import { Button, ButtonProps, ButtonGroup } from "react-bootstrap";
import "./DatePreset.scss";

export interface DatePresetProps {
  options: string[];
  selected?: string;
  onSelect: (selectedOption?: string) => void;
}

export function DatePreset({ options, selected, onSelect }: DatePresetProps) {
  type MyButtonProps = Omit<ButtonProps, "variant"> & {
    variant?: "date" | "outline-date";
    option: string;
    className: string;
    onClick: () => void;
  };

  const DateButton: FunctionComponent<MyButtonProps> = ({
    variant,
    option,
    className,
    onClick,
  }) => (
    <Button onClick={onClick} className={className} variant={variant as any}>
      {option}
    </Button>
  );

  return (
    <ButtonGroup>
      {options.map((option, index) => (
        <DateButton
          onClick={() => onSelect(option)}
          key={index}
          className="rounded-0 font-weight-bold"
          variant={option === selected ? "date" : "outline-date"}
          option={`Last ${option} days`}
        />
      ))}
      {selected ? (
        <DateButton
          onClick={() => onSelect()}
          key={"All"}
          className="rounded-0"
          variant={"outline-date"}
          option={`Reset to All Time`}
        />
      ) : null}
    </ButtonGroup>
  );
}
